import React, { useState } from 'react'
import { Input, Select, Modal, Spin, Tooltip, message } from 'antd'
import { updateProductionMethods } from '../../../../services/api/apiProductionMethods'

function EditProductionMethod(props) {
    const { item, reset } = { ...props }
    const [showEdit, setShowEdit] = useState(false)
    const [loading, setLoading] = useState(false)
    const [name, setName] = useState(item.name)
    const [code, setCode] = useState(item.code)
    const [partner, setPartner] = useState(item.partner.name)
    const [error, setError] = useState('')

    const closeEditModal = () => {
        setShowEdit(false)
    }

    const handeShowEditModal = () => {
        setName(item.name)
        setCode(item.code)
        setPartner(item.partner.name)
        setShowEdit(true)
        setError('')
    }

    const handleChangeInput = (field, e) => {
        if (field === 'name') {
            setName(e.target.value)
        }
        if (field === 'code') {
            setCode(e.target.value)
        }
    }

    const handleChangePartner = (value) => {
        setPartner(value)
    }

    const handleEdit = async () => {
        setLoading(true)
        setError('')
        const payload = {
            name: name ? name.trim() : '',
            // code: code ? code.trim() : '',
            // partner: partner ? partner.trim() : '',
        }
        try {
            const { success, message: mess } = await updateProductionMethods(item._id, payload)
            if (!success) {
                throw new Error(mess)
            }
            message.success('Phương pháp sản xuất cập nhật thành công!')
            closeEditModal()
            reset()
        } catch (error) {
            message.error(error.message)
            setError(error.message)
        } finally {
            setLoading(false)
        }
    }

    const disabledOkBtn = !name.trim() || !code.trim() || !partner.trim()

    const partnerOptions = [
        { label: 'BINH MINH', value: 'BINH MINH', },
        { label: 'QUANG MINH', value: 'QUANG MINH', },
        { label: 'TOÀN CẦU', value: 'TOÀN CẦU', },
    ]

    return (
        <div className='EditProductionMethod'>
            <Tooltip title='Chỉnh sửa'>
                <i className="icon-pencil" onClick={handeShowEditModal} />
            </Tooltip>
            <Modal
                width="600px"
                className="EditModal"
                title="Chỉnh sửa phương pháp sản xuất"
                visible={showEdit}
                onOk={handleEdit}
                onCancel={closeEditModal}
                okText='Chỉnh sửa'
                cancelText='Hủy'
                okButtonProps={{ disabled: disabledOkBtn, className: 'rounded' }}
                cancelButtonProps={{ disabled: loading, className: 'rounded' }}
                closable={!loading}
                maskClosable={!loading}
                confirmLoading={loading}
            >
                <Spin spinning={loading} tip='Loading...' size='large' >
                    <div className="createForm mt-3 mb-3">
                        <div className="createFormItem d-flex align-items-center mb-3">
                            <label className='font-weight-bold mb-0' style={{ minWidth: '117px' }} >Tên</label>
                            <Input
                                placeholder='Nhập tên ...'
                                onChange={(e) => handleChangeInput('name', e)}
                                value={name || ''}
                                allowClear
                            />
                        </div>
                        <div className="createFormItem d-flex align-items-center mb-3">
                            <label className='font-weight-bold mb-0' style={{ minWidth: '117px' }} >Mã hóa</label>
                            <Input
                                placeholder='Nhập mã ...'
                                onChange={(e) => handleChangeInput('code', e)}
                                value={code || ''}
                                allowClear
                                disabled
                            />
                        </div>
                        <div className="createFormItem d-flex align-items-center mb-3">
                            <label className='font-weight-bold mb-0' style={{ minWidth: '117px' }} >Partner</label>
                            <Select
                                placeholder='Partner sản xuất ...'
                                onChange={handleChangePartner}
                                value={partner || []}
                                allowClear
                                showArrow
                                showSearch
                                disabled
                                style={{ width: '100%' }}
                                options={partnerOptions}
                            />
                        </div>
                    </div>
                    {error &&
                        <span className="noti-error text-danger d-block mb-1">{error}</span>
                    }
                </Spin>
            </Modal>
        </div>
    )
}

export default EditProductionMethod